import { useEffect } from 'react';
import { pageTitle } from '../../helper';
import PageHeading from '../PageHeading';
import Portfolio3 from "../Portfolio/Portfolio3";
import Portfolio2 from "../Portfolio/Portfolio2";
import Div from '../Div';
import Spacing from '../Spacing';

export default function PortfolioPage() {
  pageTitle('Portfolio');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
const portfolioData = [
  {
    title: "EXSCAPE",
    subtitle: "01",
    btnText: "See Details",
    btnLink: "https://exscape.com",
    imageUrl: "/images/exscape.jpg",
    description: "A digital entertainment platform bringing games, competition and social community into one connected experience.<br/><br/>Exscape operates across multiple markets, integrating with telecom partners to deliver scalable play experiences at mass-market reach.",
  },
  {
    title: "VIBRA",
    subtitle: "02",
    btnText: "See Details",
    btnLink: "",
    imageUrl: "/images/vibra.png",
    description: "A music-powered engagement platform designed to connect audiences through interactive sound, culture and digital participation.<br/><br/>Vibra blends music discovery with community-driven mechanics tailored for telecom and brand distribution.",
  },
  {
    title: "ARENA",
    subtitle: "03",
    btnText: "See Details",
    btnLink: "",
    imageUrl: "/images/arena-img.png",
    description: "Arena is our competitive gaming venture in the Exscape ecosystem, transforming single-player gameplay into scalable competition through daily challenges, weekly leagues, and seasonal events across a growing portfolio of games. Built on a unified framework, it ensures every score is validated, every ranking is earned, and every reward is fully traceable, delivering fair, transparent competition at scale across every game.",
  },
  {
    title: "Amusement Park",
    subtitle: "04",
    btnText: "See Details",
    btnLink: "",
    imageUrl: "/images/amusementpark.webp",
    description: "A virtual IP built within Exscape, this experience invites players into a vibrant amusement park where competition is driven by collecting the most Stars, Circles, and Diamonds. Players explore the park at their own pace, navigating every ride and corner while dodging hazards and roaming characters that can cost valuable points. Blending reflex, strategy, and exploration, it transforms a simple collection mechanic into a competitive challenge where survival isn’t enough, the ultimate treasure hunter conquers the park.",
  },

];
  return (
    <>
      <PageHeading
        title="Portfolio"
        bgSrc="/images/portfolio_hero_bg.jpeg"
        pageLinkText="Portfolio"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="row">
            {portfolioData.map((item, index) =>
        index % 2 === 0 ? (
          <Div key={index}>
            <Portfolio2
              title={item.title}
              subtitle={item.subtitle}
              btnText={item.btnText}
              btnLink={item.btnLink}
              imageUrl={item.imageUrl}
              description={item.description}
            />
            <Spacing lg="100" md="70" />
          </Div>
        ) : (
          <Div key={index}>
            <Portfolio3
              title={item.title}
              subtitle={item.subtitle}
              btnText={item.btnText}
              btnLink={item.btnLink}
              imageUrl={item.imageUrl}
              description={item.description}
            />
            <Spacing lg="100" md="70" />
          </Div>
        )
      )}
        </Div>

      </Div>
    
    </>
  );
}
